module.exports = __webpack_public_path__ + "img/lovea_thumb.199be3fb.gif";